export default __webpack_public_path__ + "static/media/breeze.42e5e44a.jpeg";